import React from "react";
import FileDownload from "../FileDownload";

const DocumentDownload = ({ file }) => {
  return <FileDownload name={file?.file?.original_filename} size={file?.file?.bytes} url={file?.file?.secure_url} lightTheme />;
};

export default DocumentDownload;
